import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Paper, TextField, Typography } from "@mui/material";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import "./UserAccountPage.css";
import { useSelector } from "react-redux";

const UserPage = () => {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const understandDate = moment(user.results.createdAt, "YYYYMMDD").fromNow();
  return (
    <div className='user-page' style={{ width: "50vw" }}>
      <Box style={{ width: "100%" }}>
        <Paper
          elevation={0}
          style={{
            margin: "40px",
            display: "flex",
            flexDirection: "column",
            // borderRadius: "30px",
            width: "50%",
            backgroundColor: `${mode === "dark" ? "#101418" : "#E4EADC"}`,
            color: mode === "dark" ? "#cccccc" : "#000000",
          }}
          sx={{ height: "fit-content" }}>
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              rowGap: "10px",
              // padding: "30px",
            }}>
            <Typography variant='h5' style={{ textDecoration: "underline" }}>
              USER INFORMATION
            </Typography>
            <Typography>First Name</Typography>
            <TextField
              style={{ backgroundColor: "#ccc" }}
              value={user.results.firstName}
              InputProps={{ readOnly: true }}
              type={"text"}
              variant='filled'
            />
            <Typography>Last Name</Typography>
            <TextField
              style={{ backgroundColor: "#ccc" }}
              InputProps={{ readOnly: true }}
              value={user.results.lastName}
              type={"text"}
              variant='filled'
            />
            <Typography variant='filled'>Email</Typography>
            <TextField
              style={{ backgroundColor: "#ccc" }}
              value={user.results.email}
              InputProps={{ readOnly: true }}
              type={"text"}
              variant='filled'
            />
            <Typography variant='filled'>Branch</Typography>
            <TextField
              style={{ backgroundColor: "#ccc" }}
              value={user.results.branch}
              InputProps={{ readOnly: true }}
              type={"text"}
              variant='filled'
            />
            <Typography variant='filled'>Role</Typography>
            <TextField
              style={{ backgroundColor: "#ccc" }}
              InputProps={{ readOnly: true }}
              value={user.results.userRole}
              type={"text"}
              variant='filled'
            />
            <Typography variant='filled'>Joined At</Typography>
            <TextField
              style={{ backgroundColor: "#ccc" }}
              InputProps={{ readOnly: true }}
              value={`${user.results.createdAt} | ${understandDate}`}
              type={"text"}
              variant='filled'
            />
            <Button
              style={{ width: "fit-content" }}
              size='small'
              variant='contained'>
              UPDATE INFO
            </Button>
          </Box>
        </Paper>
      </Box>
    </div>
  );
};

export default UserPage;
